import { Component, Inject, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CountryLookupEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';

@Component({
  selector: 'app-address-fields',
  templateUrl: './address-fields.component.html',
  styleUrls: ['./address-fields.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AddressFieldComponent implements OnInit {
  @Input() set rfqData(rfqData: any) {
    if (rfqData) {
      this.rfqDetails = rfqData;
      this.addressFields.zipCode = this.rfqDetails.originZip;
    }
  }
  pattern = new CustomPattern();
  addressData: any;
  accountId: string;
  commonData = new CommonDataModel();
  addressFields: any = this.commonData.addressFieldsModel;
  countryLookupEnum: typeof CountryLookupEnum = CountryLookupEnum;
  countries: any = [];
  copyCountriesList: any = [];
  provinces: any = [];
  isLoading = false;
  isFormLoading = false;
  childForm: any = new FormControl();
  parentForm: any;
  rfqDetails: any;

  constructor(
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private contactService: ContactService,
    private toastr: ToastrService,
    private ngForm: NgForm) {
    this.parentForm = ngForm;
  }

  ngOnInit() {
    if (this.rfqDetails && this.rfqDetails.originZip.length && this.rfqDetails.originZip.length < 5) {
      this.rfqDetails.originZip = this.pad(this.rfqDetails.originZip, 5);
    }
    if (this.rfqDetails && this.rfqDetails.originZip.length === 5) {
      this.loadItems(false, this.rfqDetails);
      this.setDataForRFQ();
    } else {
      this.loadItems(true, this.rfqDetails);
    }
  }

  pad(num, size) {
    num = num.toString();
    while (num.length < size) { num = '0' + num; }
    return num;
  }

  setDataForRFQ() {
    if (this.rfqDetails) {
      this.addressFields.zipCode = this.rfqDetails.originZip;
      this.onChangeZip(this.rfqDetails.originZip, true);
    }
  }

  loadItems(isInternational: boolean, locationData: any): void {
    this.getCountries();
    if (locationData) {
      if (isInternational) {
        this.addressFields.addressLine1 = locationData.addressLine1;
        this.addressFields.addressLine2 = locationData.addressLine2;
        this.addressFields.city = locationData.city;
        this.addressFields.province = locationData.province;
        var cId = locationData.countryId;
        var countrySelectedId: number = + cId;
        this.addressFields.countryId = countrySelectedId;
      } else {
        this.addressFields.addressLine1 = locationData.addressLine1;
        this.addressFields.addressLine2 = locationData.addressLine2;
      }
    }
  }

  getCountries(): void {
    this.commonService.getCountries().subscribe(response => {
      if (response.isSuccess) {
        this.countries = response.data.map((country: {
          id: { toString: () => any; };
        }) => Object.assign(country, { id: country.id }));
      }
      this.copyCountriesList= this.countries;
      if (!this.rfqDetails) {
        this.addressFields.countryId = 1;
      }
    });
  }

  onChangeZip(searchText: string, getLocDetails: boolean): void {
    if (getLocDetails || (searchText && searchText.length >= 3 && this.addressFields.countryId == this.countryLookupEnum.USA)) {
      this.isFormLoading = true;
      this.commonService.getPostalCodeDetails(searchText)
      .pipe(finalize(() => (this.isFormLoading = false)))
      .subscribe(response => {
        if (response.isSuccess) {
          this.addressFields.countryId = response.data.countryId;
          this.addressFields.province = response.data.provinceName;
          this.addressFields.city = response.data.city;
        } else {
          this.toastr.warning(response.errors);
          this.clearLocationDetails();
        }
        this.isFormLoading = false;
      });
    } else {
      this.clearLocationDetails();
    }
  }


  onCountryChange() {
    this.addressFields.province =  null;
    this.addressFields.city = null;
    this.addressFields.zipCode = null;
  }

  clearLocationDetails() {
    this.addressFields.provinceId = null;
    this.addressFields.city = '';
  }

  bindZipCode(item: any): string | undefined {
    return item ? item.zip : undefined;
  }
  
  handleFilter(value: any) {
    this.countries = this.copyCountriesList.filter((s) => s.countryName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
  }   
}
